import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import BetbookAnalyseAuthor from '@/betbook/views/BetbookAnalyseAuthor';
import BetbookAnalysisDetail from '@/betbook/views/BetbookAnalysisDetail';
import BetbookEditPost from './BetbookEditPost';
import BetbookLobby from '@/betbook/views/BetbookLobby';
import BetbookMaintenanceScreen from 'nike-ui/src/components/maintenance/BetbookMaintenanceScreen';
import BetbookNewPost from './BetbookNewPost';
import BetbookPostDetail from './BetbookPostDetail';
import BetbookPostsAuthor from '@/betbook/views/BetbookPostsAuthor';
import BetbookTicketPosts from '@/betbook/views/BetbookTicketPosts';
import BetbookTopEvents from '@/betbook/views/BetbookTopEvents';
import React, { useEffect, useLayoutEffect } from 'react';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import i18n from '@i18n';
import useBoxStore from '@/nikeone/hook/useBoxStore';
import { BETBOOK } from '@/nikeone/context/BoxOptionsContext';
import {
    BETBOOK_TICKETS,
    COMMUNITY_ANALYSES,
    COMMUNITY_ANALYSIS_DETAIL,
    COMMUNITY_CONDITIONS,
    COMMUNITY_EDIT_ANALYSIS,
    COMMUNITY_EDIT_TICKET,
    COMMUNITY_FAQ,
    COMMUNITY_LOBBY,
    COMMUNITY_NEW_ANALYSIS,
    COMMUNITY_NEW_ANALYSIS_FROM_TICKET,
    COMMUNITY_NEW_TICKET,
    COMMUNITY_NEW_TICKET_FROM_TICKET_HASH,
    COMMUNITY_POSTS_AUTHOR,
    COMMUNITY_TICKET_DETAIL,
    COMMUNITY_TOP_EVENTS
} from '@/routing/routes';
import { BetbookAnalyse } from '@/betbook/views/BetbookAnalyse';
import { BetbookPosts } from './BetbookPosts';
import {
    POST_ANALYSIS,
    POST_TICKET,
    postTypeUrl2Enum,
    SORTING_NEW,
    SORTING_RECOMMENDED,
    sortingUrl2Enum,
    timeUrl2Enum
} from 'nike-ui/src/components/betbook/constants';
import { ParamArticle } from '@/article/views/Article';
import { clearBetbook, clearScrollPosition } from '@/betbook/handlers';
import { dispatch, dispatchSync } from 'nike-re-framejs';
import { getSportIdByName } from 'nike-ui/src/common/utils/utils';
import { isProfileBetbookMaintenance, isProfileTicketArenaEnabled } from 'nike-ui/src/profiles';
import { useActiveRoute } from 'nike-ui/src/common/routing/NikeRouteContext';
import { useLocationQuery } from 'nike-ui/src/common/routing/useLocationQuery';

// TODO: Tieto path parametre by si mala radsej citat kazda podstranka zvlast. Napriklad ticketHash je tu len kvoli BETBOOK_NEW_TICKET_FROM_TICKET_HASH .
function BetbookRoot({ postId, nickname, postType, sport, time, ticketHash }) {
    const route = useActiveRoute();
    useBoxStore('betbook', BETBOOK);
    const sortingQueryParam = useLocationQuery().get('sorting');

    useLayoutEffect(() => {
        if (
            route === COMMUNITY_LOBBY ||
            route === COMMUNITY_EDIT_ANALYSIS ||
            route === COMMUNITY_EDIT_TICKET ||
            route === COMMUNITY_NEW_ANALYSIS ||
            route === COMMUNITY_NEW_TICKET ||
            route === COMMUNITY_NEW_ANALYSIS_FROM_TICKET ||
            route === COMMUNITY_NEW_TICKET_FROM_TICKET_HASH
        ) {
            return () => dispatchSync(clearBetbook);
        }
    }, [route]);
    useEffect(() => {
        if (
            route === COMMUNITY_LOBBY ||
            route === COMMUNITY_EDIT_ANALYSIS ||
            route === COMMUNITY_EDIT_TICKET ||
            route === COMMUNITY_NEW_ANALYSIS ||
            route === COMMUNITY_NEW_TICKET ||
            route === COMMUNITY_NEW_ANALYSIS_FROM_TICKET ||
            route === COMMUNITY_NEW_TICKET_FROM_TICKET_HASH ||
            route === COMMUNITY_TOP_EVENTS
        ) {
            return () => dispatch(clearScrollPosition);
        }
    }, [route]);

    postType = postTypeUrl2Enum[postType];
    const sortType = sortingUrl2Enum[sortingQueryParam];

    time = timeUrl2Enum[time] || timeUrl2Enum[sport];
    sport = timeUrl2Enum[sport] ? null : getSportIdByName(sport);

    function getBetLocation() {
        if (route === COMMUNITY_ANALYSES) return betLocation.BETBOOK_OVERVIEW_ANALYSIS;
        if (route === BETBOOK_TICKETS) return betLocation.BETBOOK_OVERVIEW_TICKETS;
        return betLocation.BETBOOK_OVERVIEW;
    }

    if (route === COMMUNITY_TOP_EVENTS)
        return (
            <TurboLiveProvider>
                <BetbookTopEvents sport={sport} time={time} />
            </TurboLiveProvider>
        );

    if (isProfileBetbookMaintenance()) {
        return (
            <div className="centerImage mobileMaintenancePadding">
                <BetbookMaintenanceScreen
                    title={i18n('betbook.maintenance.screen.title')}
                    description={i18n('betbook.maintenance.screen.description')}
                />
            </div>
        );
    }
    if (route === COMMUNITY_LOBBY)
        return (
            <BetLocationContext.Provider value={{ betLocationSection: betLocation.BETBOOK_OVERVIEW }}>
                <BetbookLobby />
            </BetLocationContext.Provider>
        );
    if (route === COMMUNITY_ANALYSES) {
        return (
            <BetLocationContext.Provider value={{ betLocationSection: getBetLocation() }}>
                <BetbookAnalyse sortType={sortType || SORTING_RECOMMENDED} />
            </BetLocationContext.Provider>
        );
    }
    if (route === BETBOOK_TICKETS) {
        return (
            <BetLocationContext.Provider value={{ betLocationSection: getBetLocation() }}>
                {isProfileTicketArenaEnabled() ? (
                    <BetbookTicketPosts />
                ) : (
                    <BetbookPosts postType={POST_TICKET} sortType={sortType || SORTING_NEW} />
                )}
            </BetLocationContext.Provider>
        );
    }
    if (route === COMMUNITY_ANALYSIS_DETAIL)
        return (
            <BetLocationContext.Provider value={{ betLocationSection: betLocation.COMMUNITY_ANALYSIS_DETAIL }}>
                <BetbookAnalysisDetail postId={postId} />
            </BetLocationContext.Provider>
        );
    if (route === COMMUNITY_TICKET_DETAIL) return <BetbookPostDetail postType={POST_TICKET} postId={postId} />;

    if (route === COMMUNITY_EDIT_ANALYSIS) return <BetbookEditPost postType={POST_ANALYSIS} postId={postId} />;
    if (route === COMMUNITY_EDIT_TICKET) return <BetbookEditPost postType={POST_TICKET} postId={postId} />;

    if (route === COMMUNITY_NEW_ANALYSIS) return <BetbookNewPost type={POST_ANALYSIS} />;
    if (route === COMMUNITY_NEW_TICKET) return <BetbookNewPost type={POST_TICKET} />;

    if (route === COMMUNITY_NEW_TICKET_FROM_TICKET_HASH)
        return <BetbookNewPost type={POST_TICKET} ticketHash={ticketHash} />;
    if (route === COMMUNITY_NEW_ANALYSIS_FROM_TICKET) return <BetbookNewPost type={POST_ANALYSIS} />;
    if (route === COMMUNITY_POSTS_AUTHOR) {
        if (postType === POST_ANALYSIS) {
            return <BetbookAnalyseAuthor nickname={nickname} sortType={sortType || SORTING_NEW} />;
        }
        return <BetbookPostsAuthor nickname={nickname} postType={postType} sortType={sortType} />;
    }
    if (route === COMMUNITY_CONDITIONS) return <ParamArticle articleCode="komunita-podmienky" />;
    if (route === COMMUNITY_FAQ) return <ParamArticle articleCode="komunita-casto-kladene-otazky" />;
}

export default BetbookRoot;
